import React from 'react';
import { Text, View } from 'react-native';

import Tooltip from './Tooltip';

interface Props {
  children?: React.ReactNode;
}

const DisplayPrimaryTooltip: React.FC<Props> = ({ children }) => {
  return (
    <Tooltip
      testID='display-primary-tooltip'
      accessibilityLabel='Display Primary Tooltip'
      content={
        <View className='w-44 space-y-5'>
          <Text className='font-[Lato-Regular] text-sm leading-5'>
            This is the <Text className='font-[Lato-Bold]'>Primary Display</Text>
          </Text>
          <Text className='font-[Lato-Regular] text-sm leading-5'>
            Default routing presets use the Primary Display for routing shortcuts.
          </Text>
        </View>
      }>
      {children}
    </Tooltip>
  );
};

export default DisplayPrimaryTooltip;
